<template>
  <v-container fluid>
    <div>
      <!-- Automatically updated by .gitlab-ci.yml -->
      Branch: qa/1.7.1<br />
      Commit: c769fbbd<br />
      Build Date: 2026-08-12T09:13:59Z
    </div>
  </v-container>
</template>

<script>
/* eslint-disable indent */
  export default {
    name: 'Version'
  };
</script>
<style scoped>
  img {
    height: 15vh;
  }
</style>



// WEBPACK FOOTER //
// version.vue